var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{directives:[{name:"mask",rawName:"v-mask",value:(_vm.getMaskFormat),expression:"getMaskFormat"}],class:_vm.className,attrs:{"value":_vm.value,"type":_vm.type,"placeholder":_vm.placeholder,"prefix-icon":_vm.icon,"size":_vm.size,"clearable":"","disabled":_vm.disabled},on:{"input":_vm.dispatch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }